import { useSelector } from 'react-redux';

import { IAppState } from 'store';
import { IAgencyState } from 'store/agency/types';

export function useAgencyForm() {
    return useSelector<IAppState, IAgencyState['form']>(state => state.agency.form);
}

export function useAgencyOffices() {
    return useSelector<IAppState, IAgencyState['offices']>(state => state.agency.offices);
}

export function useAgencyShowProductsCard() {
    return useSelector<IAppState, IAgencyState['showProductsCard']>(state => state.agency.showProductsCard);
}
